export const PALETTE = ["#0D9488", "#1B4F8A", "#3EA8DC", "#7C3AED", "#D97706", "#DB2777", "#65A30D", "#475569", "#a8a29e"];

export const DIMENSIONS = [
  { id: "team", label: "Team" },
  { id: "pm", label: "PM" },
  { id: "study_type", label: "Study type" },
  { id: "client", label: "Client" },
  { id: "qual_quant", label: "Qual/Quant" },
];

export const GRAINS = [
  { id: "year", label: "Year" },
  { id: "quarter", label: "Quarter" },
  { id: "month", label: "Month" },
];

export const METRICS = [
  { id: "revenue", label: "Revenue" },
  { id: "gp", label: "Gross profit" },
  { id: "margin", label: "Margin %" },
];

export const ADDITIVE = new Set(["revenue", "gp"]);

export const BASES = [
  { id: "all", label: "All" },
  { id: "verified", label: "Verified only" },
  { id: "live", label: "Live estimates only" },
];

export const GP_SOURCE_LABELS = {
  project_margin: "est · project margin",
  flow_stamp: "est · Cognito stamp",
  client_blend: "est · client history",
  baseline: "est · 45% baseline",
};

export const metricValue = (c, metric) => {
  if (!c) return null;
  if (metric === "revenue") return c.revenue;
  if (metric === "gp") return c.gp;
  return c.margin_pct;
};

export const fmtPeriod = (p) => {
  if (/^\d{4}$/.test(p)) return p;
  if (p.includes("Q")) return `${p.slice(5)} ${p.slice(2, 4)}`;
  const [y, m] = p.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-GB", { month: "short", year: "2-digit" });
};
